import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function ShipFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10 3a1 1 0 011-1h2.5a1 1 0 110 2H11a1 1 0 01-1-1zm-.646 4a1 1 0 00-.928.629l-.993 2.482 3.84-.96a3 3 0 011.455 0l3.84.96-.994-2.482A1 1 0 0014.646 7H9.354zm-4.282 3.629c-.011.026-.02.053-.029.08l-.315.078a2 2 0 00-1.456 2.426l1.536 6.144c-.252.058-.486.12-.7.182-.515.149-1.034.319-1.519.549a1 1 0 10.854 1.809 8.557 8.557 0 011.22-.436c.8-.232 1.916-.461 3.183-.461 1.28 0 2.576.231 3.976.484 1.432.258 2.873.516 4.332.516 1.502 0 2.809-.27 3.739-.54a9.953 9.953 0 001.519-.549 1 1 0 10-.855-1.808 9.202 9.202 0 01-1.31.462l1.5-6.376a2 2 0 00-1.461-2.398l-.33-.083a1.05 1.05 0 00-.027-.08L17.43 6.887A3 3 0 0014.646 5H9.354A3 3 0 006.57 6.886l-1.497 3.743z",
    clipRule: "evenodd"
  }));
}

export default ShipFill;